import { render, staticRenderFns } from "./FieldOrRule.vue?vue&type=template&id=12e7dfe6&scoped=true"
import script from "./FieldOrRule.vue?vue&type=script&lang=js"
export * from "./FieldOrRule.vue?vue&type=script&lang=js"
import style0 from "./FieldOrRule.vue?vue&type=style&index=0&id=12e7dfe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e7dfe6",
  null
  
)

export default component.exports